import {Component, HostListener, Inject, Input, LOCALE_ID, OnInit} from '@angular/core';
import {HeaderAction} from '../model/header-action';
import {LanguageLink} from '../model/language-link';
import {HeaderMenuSeparator} from '../model/header-menu-separator';
import {HeaderMenuItem} from '../model/header-menu-item';
import {HeaderMenuLink} from '../model/header-menu-link';
import {Location} from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import {PasswordChangeComponent} from '../password-change/password-change.component';
import {MatDialog} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'lib-app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.css']
})
export class AppHeaderComponent implements OnInit {

  @Input() appTitle: string;
  @Input() appTitleShort: string;
  @Input() actions: HeaderMenuItem[];
  @Input() aisUrl: string;
  @Input() userName: string;
  @Input() red = false;
  @Input() shadow = true;
  @Input() httpParams: HttpParams;
  @Input() languageLinks: LanguageLink[];
  @Input() translate: TranslateService;

  menuVisible1 = false;
  menuVisible2 = false;
  private myButton = false;
  public passwordChangeAllowed = false;
  public appIdText: string;
  private supportedLanguages: string[];


  constructor(
      private location: Location,
      public dialog: MatDialog,
      public http: HttpClient,
      @Inject(LOCALE_ID) private locale: string,
  ) { }

  ngOnInit()
  {
      if (!this.aisUrl || !this.aisUrl.includes('lng=')) {
        this.aisUrl = (this.aisUrl ? this.aisUrl : '/ais/start.do' ) + '?lng=' + this.locale;
      }

      this.http
          .get<boolean>('/ais/rest/portal/user/password')
          .subscribe(
            data => {
               this.passwordChangeAllowed = data;
            }
          );

      this.http
        .get<{appIdText: string}>('/ais/rest/portal/app/id-text')
        .subscribe(
          data => {
            console.log(data);
            this.appIdText = data.appIdText;
          }
        );

      this.http
        .get<string[]|null>('/ais/rest/portal/app/languages')
        .subscribe(
          data => {
            console.log(data);
            this.supportedLanguages = data;
          }
        );
  }

  switchMenu1() {
    this.menuVisible1 = !this.menuVisible1;
    if (this.menuVisible2) {
      this.menuVisible2 = false;
    }
    this.myButton = true;
  }

  switchMenu2() {
    this.menuVisible2 = !this.menuVisible2;
    if (this.menuVisible1) {
      this.menuVisible1 = false;
    }
    this.myButton = true;
  }

  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    if (this.menuVisible1) {
      this.switchMenu1();
    }
    if (this.menuVisible2) {
      this.switchMenu2();
    }
    this.myButton = false;
  }

  @HostListener('document:click', ['$event'])
  onMouseClick(event: MouseEvent) {
    if (!this.myButton && this.menuVisible1) {
      this.switchMenu1();
    }
    if (!this.myButton && this.menuVisible2) {
      this.switchMenu2();
    }
    this.myButton = false;
  }

  isHeaderAction(a: HeaderMenuItem) {
    return a instanceof HeaderAction;
  }

  isHeaderSeparator(a: HeaderMenuItem) {
    return a instanceof HeaderMenuSeparator;
  }

  isHeaderMenuLink(a: HeaderMenuItem) {
    return a instanceof HeaderMenuLink;
  }

  goToLanguageVersion(lng: string) {
    let path = '..\\' + lng;
    if (this.httpParams.keys().length > 0 ) {
      path += '?' + this.httpParams.toString();
    }
    console.log('path=' + path);
    window.location.href = path;
  }

  changePassword() {
    if (this.translate) {
      this.dialog.open(PasswordChangeComponent, {
        data: {translate: this.translate},
      });
    }
  }

  getLanguageName(kodJazyk: string) {

    let result = '';
    switch (kodJazyk.toUpperCase()) {
      case 'SK':
        result = 'Slovenský';
        break;
      case 'EN':
        result = 'English';
        break;
      case 'HU':
        result = 'Magyar';
        break;

      default:
        break;
    }

    return result;

  }

  isLanguageSupported(lng: string) {
    return this.supportedLanguages && this.supportedLanguages.indexOf(lng.toLowerCase()) > -1;
  }
}
